import { render, staticRenderFns } from "./SingleIntro.vue?vue&type=template&id=9788707c&lang=pug&"
import script from "./SingleIntro.vue?vue&type=script&lang=js&"
export * from "./SingleIntro.vue?vue&type=script&lang=js&"
import style0 from "./SingleIntro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports